import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea"]

  insertVariable(event) {
    const variable = event.currentTarget.dataset.variable
    const textarea = this.textareaTarget
    
    if (variable && textarea) {
      const cursorPosition = textarea.selectionStart
      const textBefore = textarea.value.substring(0, cursorPosition)
      const textAfter = textarea.value.substring(cursorPosition)
      const variableText = `{{${variable}}}`
      
      textarea.value = textBefore + variableText + textAfter
      
      // Repositionner le curseur après la variable insérée
      const newCursorPosition = cursorPosition + variableText.length
      textarea.setSelectionRange(newCursorPosition, newCursorPosition)
      textarea.focus()
      
      // Déclencher l'événement input pour les validations éventuelles
      textarea.dispatchEvent(new Event('input', { bubbles: true }))
    }
  }
}
